module.exports = __webpack_public_path__ + "img/logo_side_round_white_w200.826f5716.png";